import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Prioritize from "./prioritize";
import Rank from "./rank";
import { StepProps } from "../../../../../../../utils/types/step";
import ChangeIdeaGeneration from "./changeIdea";


const Prioritization = (props: StepProps) => {
  const [selectedSteps, setSelectedSteps] = useState(0);

  const handleTabsChange = (index: number) => {
    console.log("index", index);
    
    setSelectedSteps(index);
  };


  useEffect(()=>{
    console.log("selected step: ", selectedSteps, props.goToLastStep);
    
  }, []);

  const steps = [
    {
      title: "Problem List",
      description: "Problem Listing",
      component: (
        <Prioritize
          onNext={() => handleTabsChange(1)}
          onPrev={() => props.onPrev && props.onPrev()}
          onSave={props.onNext}
          loading={props.loading}
        />
      ),
    },
    {
      title: "Problem Ranking",
      description: "Ranking of Problems",
      component: (
        <Rank
          onNext={() => handleTabsChange(2)}
          onPrev={() => handleTabsChange(0)}
          
        />
      ),
    },
    {
      title: "Change Ideas",
      description: "Provide Change Ideas",
      component: (
        <ChangeIdeaGeneration
          onNext={() => props.onNext()}
          onPrev={() => handleTabsChange(1)}
          onSave={()=> console.log("save")}
          loading={props.loading}
        />
      ),
    },
  ];
  return (
    <Box
      m={5}
      w={"100%"}
      h={"full"}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"flex-start"}
      gap={4}
    >
      <Box bg={"gray.50"} w={"15%"} h={"85%"} borderRadius={5} p={5}>
        <Stepper index={selectedSteps} orientation="vertical" h={"50%"} my={10}>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepIndicator>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <Box flexShrink="0" textAlign={"left"}>
                <StepTitle> {step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </Box>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
      </Box>
      {/* <Divider orientation="vertical" /> */}
      <Box w={"85%"} mt={10} h={"full"}>
        {steps[selectedSteps].component}
      </Box>
    </Box>
  );
};

export default Prioritization;
